module.exports = __webpack_public_path__ + "img/written-answer.a04f712e.svg";